import {Tooltip} from '@mui/material'
import {Box, Loading, Skeleton, Typography} from '@viptech/react-components'
import React from 'react'
import usePersonalizedThemeByCompany from 'src/hooks/usePersonalizedThemeByCompany'

type Item = {
  name: string
  value?: number
  percentage?: number
  icon?: React.ReactNode
}

type Props = {
  title: string
  subtitle?: string
  loading: boolean
  data: Array<Item>
  refetching?: boolean
  height?: string
}

export default function DashboardTableRowCard({title, refetching, data, loading, height = '320px', subtitle}: Props) {
  const {styledTheme} = usePersonalizedThemeByCompany()

  return (
    <Box backgroundColor='white' position='relative' borderRadius='16px' width='100%' height={height} style={{boxShadow: '0px 5px 8px 0px #00000026'}}>
      <Box display='flex' direction='column' padding='24px' rowGap='6px' align='center'>
        <Typography variant='span' size='16px' color={styledTheme.dashboard.colors.title} children={title} weight={600} />
        <Typography variant='span' size='12px' color={styledTheme.dashboard.colors.title} style={{fontStyle: 'italic'}} children={subtitle?.replace('.', '')} />

        {refetching && !loading && (
          <Tooltip title='Buscando atualizações' placement='top'>
            <Box position='absolute' right='24px' display='flex' columnGap='8px'>
              <Loading size='20px' />
            </Box>
          </Tooltip>
        )}

        <Box display='flex' width='100%' direction='column' rowGap='24px'>
          <Box display='flex' width='100%' direction='column' rowGap='10px' marginTop='12px' overflow='hidden'>
            {loading && !data.length
              ? new Array(Math.round(Number(height.replace('px', '')) / 78)).fill(0).map((_, index) => (
                  <Box key={index}>
                    <Skeleton height='48px' width='100%' borderRadius='8px' />
                  </Box>
                ))
              : data.map((item, index) => (
                  <Box
                    display='flex'
                    flexWrap='wrap'
                    rowGap='8px'
                    key={index}
                    justify='space-between'
                    backgroundColor='#F2F4F7'
                    padding='12px 24px'
                    borderRadius='16px'>
                    <Box display='flex' columnGap='16px' align='center'>
                      {item.icon}
                      <Typography variant='label' size='14px' weight={600} children={item.name} />
                    </Box>

                    <Box display='flex' justifyContent='flex-end' align='center' columnGap='24px'>
                      {loading ? (
                        <Box marginTop='4px'>
                          <Skeleton height='24px' width='50px' borderRadius='8px' />
                        </Box>
                      ) : (
                        <Typography variant='label' size='20px' weight={700} color='#344054'>
                          {!!item.value && item.value >= 0 ? item.value : '-'}
                        </Typography>
                      )}

                      {!!item.percentage && !loading && (
                        <Box borderRadius='8px' backgroundColor='#C9E6FF' padding='4px 16px' width='40px' display='flex' align='center' justifyContent='center'>
                          <Typography variant='label' size='14px' weight={700} color='#0B62B9'>
                            {item.percentage.toFixed(0)}%
                          </Typography>
                        </Box>
                      )}
                    </Box>
                  </Box>
                ))}
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
